import React, { Component } from "react";
// import { Mode } from "rc-select/lib/interface";
import Select from "../select";
import Table from "../table";
import { ColumnProps } from "antd/lib/table";
import PropTypes from "prop-types";
import cloneDeep from "lodash/cloneDeep";
import isEqual from "lodash/isEqual";
import PagePoint from "../page-point/index";

const { Option } = Select;
const {
  sendPagePoint,
  pagePointConfig: { regKey },
  EventType: { clickType },
} = PagePoint;
interface ISelectProps {
  mode: "multiple" | "tags";
}

interface ITableProps {
  dataSource: object[];
  rowKey: string;
  display: string;
  columns: ColumnProps<object>[];
}

interface IChangeObj {
  value?: string | string[] | number;
  update?: boolean;
  tableData?: object[];
}

type TSProps = {
  value: string | string[] | number;
  selectProps: ISelectProps;
  tableProps: ITableProps;
  onChange: (key: string | string[]) => void;
};

type TSState = {
  value: string | string[] | number;
  open: boolean;
  update: boolean;
  tableData?: object[];
};

const transfer = (item) => (item ? item.toString().toLowerCase() : item);
export default class TableSelect extends Component<TSProps, TSState> {
  static propTypes = {
    /* eslint-disable */
    tableProps: PropTypes.shape({
      display: PropTypes.string.isRequired,
    }),
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.array,
    ]),
  };

  static defaultProps = {
    update: false,
  };

  select: any;
  origValue: any;

  constructor(props) {
    super(props);
    const {
      value,
      selectProps: { mode },
      tableProps: { dataSource },
    } = this.props;
    this.state = {
      value: value || (mode === "multiple" ? [] : ""),
      open: false,
      update: false, //更新表格内部状态都需要把update置为true, 切记切记！
      tableData: cloneDeep(dataSource),
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let changeObj: IChangeObj = {};
    if (!isEqual(nextProps.tableProps.dataSource, prevState.tableData)) {
      if (nextProps.update === prevState.update) {
        changeObj.tableData = cloneDeep(nextProps.tableProps.dataSource);
      } else {
        changeObj.update = false;
      }
    }
    if (!isEqual(nextProps.value, prevState.value)) {
      if (nextProps.update === prevState.update) {
        changeObj.value = nextProps.value;
      } else {
        changeObj.update = false;
      }
    }
    return Object.keys(changeObj).length ? changeObj : null;
  }

  setRef = (select) => {
    this.select = select;
  };

  onDropdownVisibleChange = (open) => {
    const {
      tableProps: { dataSource },
    } = this.props;
    this.setState({ open, update: true, ...(open ? { tableData: dataSource } : {}) });
  };

  clickRow = (record) => {
    const {
      selectProps: { mode },
      tableProps: { rowKey },
    } = this.props;
    const { value } = this.state;
    if (record && mode !== "multiple") {
      this.setState({ value: record[rowKey], open: false, update: true });
      if (value !== record[rowKey]) {
        this.triggerChange(record[rowKey]);
      }
    }
  };

  triggerChange = (value) => {
    const { [regKey]: dataRegId, onChange } = this.props as any;
    const valueStr = JSON.stringify(value);
    if (dataRegId) {
      sendPagePoint({
        eventType: clickType,
        tagname: "tableSelect",
        value: valueStr,
        [regKey]: dataRegId,
        origValue: this.origValue,
      });
      this.origValue = valueStr;
    }
    onChange && onChange(value);
  };

  renderOptions = (data) => {
    const arr = [];
    const {
      tableProps: { rowKey, display },
    } = this.props;
    for (const item of data) {
      arr.push(
        <Option key={item[rowKey]} value={item[rowKey]}>
          {item[display]}
        </Option>
      );
    }
    return arr;
  };

  deselect = (val) => {
    const { value } = this.state;
    this.triggerChange((value as string[]).filter((item) => item !== val));
    this.setState((prevState) => {
      return {
        value: (prevState.value as string[]).filter((item) => item !== val),
        update: true,
      };
    });
  };

  selectChange = (selectedRowKeys) => {
    const {
      tableProps: { dataSource },
    } = this.props;
    this.triggerChange(selectedRowKeys);
    this.setState({
      value: selectedRowKeys,
      tableData: dataSource,
      update: true,
    });
  };

  searchTable = (value) => {
    // columns key依次模糊匹配
    const { open } = this.state;
    const {
      tableProps: { dataSource, columns, display },
    } = this.props;
    if (open) {
      const keys = columns
        .map((v) => {
          if (v.dataIndex !== display) {
            return v.dataIndex;
          }
          return null;
        })
        .filter((v) => v);
      const res = value
        ? dataSource.filter((item) => {
            if (transfer(item[display]).includes(transfer(value))) {
              return true;
            }
            for (let i = 0; i < keys.length; i += 1) {
              if (
                item[keys[i]] &&
                transfer(item[keys[i]]).includes(transfer(value))
              ) {
                return true;
              }
            }
            return false;
          })
        : dataSource;
      this.setState({ tableData: res, update: true });
    }
  };

  render() {
    const { value, open, tableData } = this.state;
    const {
      tableProps,
      selectProps,
      selectProps: { mode },
    } = this.props;
    const options = this.renderOptions(tableData);
    const rowSelection = {
      selectedRowKeys: (value as string[] | number[]) || [],
      onChange: this.selectChange,
    };
    const tableMultiOpts = mode === "multiple" ? { rowSelection } : {};
    const selectMultiOpts =
      mode === "multiple" ? { onDeselect: this.deselect } : {};
    const tableOpts = {
      ...tableProps,
      ...tableMultiOpts,
      dataSource: tableData,
      bordered: false,
    };
    const selectOpts = {
      ...selectProps,
      ...selectMultiOpts,
      open,
      value,
      onDropdownVisibleChange: this.onDropdownVisibleChange,
      onSearch: this.searchTable,
      dropdownRender: () => (
        <Table
          {...tableOpts}
          onRow={(record) => ({
            onMouseDown: () => {
              this.clickRow(record);
            },
          })}
          onHeaderRow={() => ({
            onMouseDown: () => {
              this.clickRow(null);
            },
          })}
        />
      ),
    };
    return (
      <Select ref={this.setRef} {...selectOpts}>
        {options}
      </Select>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/table-select/index.tsx